<div class="my-catalog-suggestions-container">
  <div class="header-container">
    <h1 class="title">My Catalog Suggestions</h1>
    <app-search-filter
      id="search"
      [value]="searchQuery"
      placeholder="Search Catalog Suggestion"
      (valueChange)="searchQueryChanged($event)"
    />
    <app-new-button
      id="create-button"
      color="green"
      size="sm"
      customPadding="10px 16px"
      customFontSize="16px"
      leftIcon="add"
      (clickHandler)="toggleCreateModal()"
    >
      Submit Catalog Suggestion
    </app-new-button>
  </div>
  <div class="table-container">
    <app-new-table
      id="my-catalog-suggestions-table"
      [isLoading]="loading"
      [tableData]="newTableData"
      (burgerMenuClickedEvent)="handleMeatballClick($event)"
      (rowClickedEvent)="handleRowClick($event)"
      (sortClickedEvent)="handleSortEvent($event)"
      (pageChanged)="onPageChanged($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)"
      (noDataButtonClickedEvent)="toggleCreateModal()"
    />
  </div>
</div>
